<template>
  <RoomTable
    class="cursor-pointer"
    :shape="table.shape"
    :rotation="table.rotation"
    :width="table.w"
    :height="table.h"
    :x="table.x"
    :y="table.y"
    :class="{
      'opacity-30': lowOpacity,
      '[&_text]:italic': updateStatus !== TABLE_UPDATE_STATUS.AVAILABLE
    }"
    :fillClass="styles.fillClass"
    :textFillClass="styles.textFillClass"
    :strokeClass="styles.strokeClass"
    :draggable="draggable"
    @update:position="updateTablePosition"
  >
    {{ table.name }}
  </RoomTable>
</template>

<script lang="ts" setup>
import { computed, toRefs } from 'vue'

import RoomTable from '@/common/components/molecules/RoomTable.vue'
import {
  TABLE_UPDATE_STATUS,
  TableStatus,
} from '@/modules/performance/interfaces/PerformanceTableInterfaces'
import { PerformanceTableWithReservations } from '@/modules/performance/stores/PerformanceReservationStore'
import { usePerformanceUpdateStore } from '@/modules/performance/stores/PerformanceUpdateStore'

import { ReservationStatus, ReservationStatusType } from '@generated/types'

type TableStyle = {
  fillClass: string
  textFillClass: string
  strokeClass: string
}

const props = defineProps<{
  draggable: boolean
  table: PerformanceTableWithReservations
  reservationStatus: ReservationStatusType
  updateStatus: TableStatus
  filled: boolean
  lowOpacity: boolean
}>()
const { table, reservationStatus, lowOpacity, filled } = toRefs(props)
const performanceUpdateStore = usePerformanceUpdateStore()
function updateTablePosition(position: { x: number; y: number }) {
  performanceUpdateStore.updateTable({ id: table.value.id, ...position })
}

const styles = computed<TableStyle>(() => {
  let fillClass: string
  let textFillClass: string
  let strokeClass: string

  switch (reservationStatus.value) {
    case ReservationStatus.EXPECTED:
      strokeClass = 'stroke-status-expected'
      break
    case ReservationStatus.ARRIVED:
      strokeClass = 'stroke-status-waiting'
      break
    case ReservationStatus.SEATED:
      strokeClass = 'stroke-status-seated'
      break
    case ReservationStatus.NO_SHOW:
    case ReservationStatus.UNPAID:
      strokeClass = 'stroke-status-noshow'
      break
    default:
      strokeClass = 'stroke-status-available'
  }

  if (filled.value) {
    fillClass = 'fill-surface-table-reserved'
    textFillClass = 'fill-fg-table'
  } else {
    fillClass = 'fill-surface-table-available'
    textFillClass = 'fill-fg-table-available'
  }

  return { fillClass, textFillClass, strokeClass }
})
</script>
